import generateAsyncActions from 'utils/generateAsyncActions';
import alt from 'components/Dispatcher';
import CrmContactSource from 'sources/crm-opp-ui/CrmContactSource';

class CrmContactActions {
  constructor() {
    this.generateActions(
      ...generateAsyncActions('fetchContact', 'searchContacts'),
      'clearSearch',
      'setSearchTerm'
    );
  }

  searchContacts(searchTerm) {
    return dispatch => {
      dispatch(searchTerm);
      if (searchTerm && searchTerm.length >= 3) {
        CrmContactSource.searchContacts(searchTerm).then(
          this.searchContactsSuccess,
          this.searchContactsError
        );
      }
    };
  }

  fetchContact(id) {
    return dispatch => {
      dispatch(id);
      return CrmContactSource.fetchContact(id).then(
        this.fetchContactSuccess,
        this.fetchContactError
      );
    };
  }
}

export default alt.createActions(CrmContactActions);
